import React from 'react';
import { Link } from 'react-router-dom';
import 'css/Header.css';
import { KoFiDialog, KoFiButton } from 'react-kofi';
import 'react-kofi/dist/styles.css';
import NavMenu from 'components/NavMenu';

const OtherCalcs: React.FC = () => {
  return (
    <div id="other-links">
      <KoFiButton color="#00b4f7" id="tedzeppelin121" label="Support Fat Scientist on Ko-Fi" radius="12px" />
      <h2>Calculators</h2>
      <div>
        <Link to="/dosage-calculator">Tirzepatide Dosage Calculator</Link>
        <div className="smaller-text">Calculate dosage for Tirzepatide (Mounjaro/Zepbound)</div>
      </div>
      <div>
        <Link to="/semaglutide-calculator">Semaglutide Dosage Calculator</Link>
        <div className="smaller-text">Calculate dosage for Semaglutide (Ozempic/Wegovy)</div>
      </div>
      <div>
        <Link to="/reverse-dosage-calculator">Reverse Dosage Calculator</Link>
        <div className="smaller-text">How much did you take? Calculate the dosage from the units you injected.</div>
      </div>
      <div>
        <Link to="/zepbound-reverse-calculator">Zepbound Reverse Dosage Calculator</Link>
        <div className="smaller-text">
          For Zepbound vials: Calculate dosage from units injected and vial's listed dose.
        </div>
      </div>
      <div>
        <Link to="/vial-transition-calculator">Vial Transition Dosage Calculator</Link>
        <div className="smaller-text">
          Combine doses from two vials (e.g., when finishing one and starting another).
        </div>
      </div>
      <div>
        <Link to="/split-dose-calculator">Split Dose Calculator</Link>
        <div className="smaller-text">
          Convert weekly doses to more frequent schedules (e.g., every 5 days instead of weekly).
        </div>
      </div>
      <div>
        <Link to="/ousia-dosage-calculator">Ousia Dosage Calculator</Link>
        <div className="smaller-text">Special dosage calculator for Ousia vials</div>
      </div>

      <h2>Guides and FAQs</h2>

      <div>
        <Link to="/faq/finding-concentration">Finding Your Medication Concentration</Link>
        <div className="smaller-text">Learn how to find and understand your medication's concentration</div>
      </div>
      <div>
        <Link to="/faq/starting-today-how-to-prepare">Starting Today: What You Need To Know</Link>
        <div className="smaller-text">Some things you'll want to know when starting your weight loss journey</div>
      </div>
    </div>
  );
};

export default OtherCalcs;
